import React from "react"
import GravityFormForm from "gatsby-plugin-gravity-forms"
import { useStaticQuery, graphql } from "gatsby"

const handleError = ({ values, error, reset }) => {
  //handle error
}

const handleSuccess = ({ values, reset, confirmations }) => {
  //handle success
}

const ContactForm = ({ currentBrand }) => {
  const brandValue = currentBrand ? `Brand: ${currentBrand.brandStyle}` : "Brand: "
  const data = useStaticQuery(
    graphql`
      query {
        wpGfForm(databaseId: { eq: 3 }) {
          ...GravityFormFields
        }
      }
    `
  )
  return (
    <div className="uppercase">
    <GravityFormForm
      data={data}
      lambda={process.env.GATSBY_LAMBDA_ENDPOINT}
      successCallback={handleSuccess}
      errorCallback={handleError}
      presetValues={{ input_11: brandValue }}
    />
    </div>
  )
}

export default ContactForm
